import { useIntl } from 'react-intl';

import { playerGameStatusLabels } from 'lib/glossary';

export const NotCoveredLabel = () => {
  const { formatMessage } = useIntl();
  return <span>{formatMessage(playerGameStatusLabels.not_covered)}</span>;
};

export const UncertainCoverageLabel = () => {
  const { formatMessage } = useIntl();
  return (
    <span>{formatMessage(playerGameStatusLabels.uncertain_coverage)}</span>
  );
};

export const LowCoverageLabel = () => {
  const { formatMessage } = useIntl();
  return <span>{formatMessage(playerGameStatusLabels.low_coverage)}</span>;
};
